var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-bar',{ref:"select-bar",staticClass:"p-p-3 p-d-flex p-jc-between",on:{"updateGrade":_vm.updateGrade,"updateReportName":_vm.updateReportName}}),_c('menage-list',{staticClass:"p-p-3",attrs:{"selectedGrade":_vm.selectedGrade,"selectedReportName":_vm.selectedReportName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }